import React from "react";
import { Alert, Box, useTheme, alpha } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import { useAppState } from "../store/contextProvider";

const IAPIError = () => {
  const { pageState } = useAppState();
  const theme = useTheme();
  if (!pageState?.pageError) return null;
  return (
    <Box
      sx={{
        mb: 1,
        mt: 0,
        animation: "fadeIn 0.3s ease-in",
        "@keyframes fadeIn": {
          from: { opacity: 0, transform: "translateY(-10px)" },
          to: { opacity: 1, transform: "translateY(0)" },
        },
      }}
    >
      <Alert
        severity="error"
        icon={<ErrorOutline sx={{ fontSize: "1.1rem" }} />}
        sx={{
          borderRadius: "8px",
          border: `1px solid ${alpha(theme.palette.error.main, 0.3)}`,
          backgroundColor: alpha(theme.palette.error.main, 0.08),
          color: theme.palette.error.main,
          boxShadow: `0 2px 8px ${alpha(theme.palette.error.main, 0.15)}`,
          py: 0.5,
          px: 1.5,
          "& .MuiAlert-icon": {
            color: theme.palette.error.main,
            fontSize: "1.1rem",
            padding: 0,
            marginRight: 1,
          },
          "& .MuiAlert-message": {
            fontWeight: 500,
            fontSize: "0.875rem",
            lineHeight: 1.4,
            width: "100%",
            padding: 0,
          },
          "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: "3px",
            backgroundColor: theme.palette.error.main,
            borderRadius: "8px 0 0 8px",
          },
          position: "relative",
          paddingLeft: "12px",
          minHeight: "auto",
        }}
      >
        {pageState.pageError}
      </Alert>
    </Box>
  );
};

export default IAPIError;
